import React, { useState } from 'react'
import DOMPurify from 'dompurify'
import { ChevronDownSmall } from 'src/components/Icons/ChevronDownSmall'

interface FaqItem {
  active: boolean
  question: string
  response: string
}

interface FaqSectionProps {
  title: string
  subTitle?: string
  items: FaqItem[]
}

const FaqSection: React.FC<FaqSectionProps> = ({ title, subTitle, items }) => {
  const [openIdx, setOpenIdx] = useState<number | null>(null)

  return (
    <section className="w-full max-w-[1142px] mx-auto md:mt-28 mt-10 md:mb-16 mb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6 gap-1 px-4 md:px-0">
        <div>
          <h2 className="text-[#101010] text-2xl md:text-3xl md:font-bold font-medium md:mt-6 mt-2 md:mb-4 mb-2">
            {title}
          </h2>
          {subTitle && (
            <div
              className="text-[#101010] text-base [&_a]:underline [&_a]:font-semibold"
              dangerouslySetInnerHTML={{
                __html:
                  typeof DOMPurify?.sanitize === 'function'
                    ? DOMPurify?.sanitize(subTitle)
                    : subTitle,
              }}
            />
          )}
        </div>
        <div>
          <ul>
            {items
              .filter((item) => item.active !== false)
              .map((item, idx) => (
                <li key={idx} className="border-b border-[#E5E5E5]">
                  <button
                    className="w-full flex items-center justify-between py-5 text-left focus:outline-none"
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  >
                    <span className="text-[#101010] text-base font-medium">
                      {item.question}
                    </span>
                    <span
                      className={`ml-2 transition-transform duration-200 ${
                        openIdx === idx ? 'rotate-180' : ''
                      }`}
                    >
                      <ChevronDownSmall />
                    </span>
                  </button>
                  {openIdx === idx && (
                    <div
                      className="text-[#101010] text-base pb-5 pl-1 [&_a]:underline [&_a]:font-semibold"
                      dangerouslySetInnerHTML={{
                        __html:
                          typeof DOMPurify?.sanitize === 'function'
                            ? DOMPurify?.sanitize(item.response)
                            : item.response,
                      }}
                    />
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default FaqSection
